import { Button, DialogActions } from '@mui/material'
import LoadingShort from '../load/loadingShort'
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    button: {
        transition: '.5s',
        '&:hover': { transform: 'scale(1.1)' },

        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
}))
export default function ButtonLeft({ title, funcao, disabled, load, children }) {
    const classes = useStyles()

    return (
        <DialogActions>
            {children && children}
            <Button className={classes.button}  style={{ backgroundColor: '#85287e' }} disabled={disabled || load} variant="contained" onClick={funcao}>{load ? <LoadingShort /> : title}</Button>
        </DialogActions>
    )
}
